module.exports = __webpack_public_path__ + "static/phil-9d7d610f3ae2906f99bf17ba90cde828.png";